import router from '@/router'
import { asyncCeshi, constantRouterMap } from '@/router'
import Cookies from 'js-cookie'
import formCheck from "@/common_js/formCheck.js";
import SvrApi from "@/svrapi";
import EnvBase from "@/env";

var PT = EnvBase.PT;

const route_processe = {
  state: {
    // routers: constantRouterMap,
    addRouters: [],
    order_route: false,
    revenue_route: false,
    list_route: false,
    record_route:false,
    wait_route:false,
  },
  mutations: {
    SET_ORDER_ROUTER: (state, router) => {
      state.order_route = router
    },
    SET_REVENUE_ROUTER: (state, router) => {
      state.revenue_route = router
    },
    SET_LIST_ROUTER: (state, router) => {
      state.list_route = router
    },
    SET_RECORD_ROUTER: (state, router) => {
      state.record_route = router
    },
    SET_WAIT_ROUTER: (state, router) => {
      state.wait_route = router
    },
    SET_ROUTE: (state, view) => {
      // console.log(view)
      // console.log(router)
      // console.log(router.addRoutes)
      // router.beforeEach((to, from, next) => {
      //   console.log(store.getters.addRouters)
      //   NProgress.start()
      //   console.log(asyncCeshi)
      //   router.addRoutes(asyncCeshi)
      //   next() // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
      // })

      // router.afterEach(() => {
      //   NProgress.done() // 结束Progress
      // })
    },
  },
  actions: {
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        //开始执行鉴权请求
        PT.apiClient.query("bz-mix/bz/get-base-info", '', function (rsp) {
          resolve(rsp)
        });
      })
    },
  }
}

export default route_processe


// WEBPACK FOOTER //
// ./src/store/modules/route_processe.js